import { useEffect, useState } from 'react';
import SupBilling from './supBilling';
import SupPayouts from './supPayouts';
import Tab from '../../components/tabs/tabs';
import { getOrganizers } from '../../utils/getOrganizers';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ReactLoading from 'react-loading';

const MODE_TO_SERVICE = {
    t: 'trip',
    a: 'act',
    c: 'camp',
    g: 'gu'
};

const SupPaymentsTab = () => {
    const { orgId, mode } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('Billing');
    const [orgData, setOrgData] = useState([]);
    const [loading, setLoading] = useState(false);
    const serviceType = MODE_TO_SERVICE[mode];

    useEffect(() => {
        const fetchOrg = async () => {
            getOrganizers(serviceType, setOrgData, setLoading);
        };
        fetchOrg();
    }, [serviceType, activeTab]);

    useEffect(() => {
        if (location.pathname.includes('payouts')) {
            setActiveTab('Payouts');
        } else {
            setActiveTab('Billing');
        }
    }, [location.pathname]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        navigate(
            tab === 'Billing'
                ? `/support/${mode}/billings/${orgId}?status=completed&approval=approved&page=1`
                : `/support/${mode}/payouts/${orgId}?page=1`
        );
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='tabContainer bookingSticky'>
                <Tab label='Billing' value={'Billing'} activeTab={activeTab} setActiveTab={handleTabChange} />
                <Tab label='Payouts' value={'Payouts'} activeTab={activeTab} setActiveTab={handleTabChange} />
            </div>
            <div>
                {activeTab === 'Billing' && <SupBilling orgData={orgData} />}
                {activeTab === 'Payouts' && <SupPayouts orgData={orgData} />}
            </div>
        </>
    );
};

export default SupPaymentsTab;
